import {
  Component,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  SimpleChanges,
  Injectable
} from '@angular/core';
import { WeekPipe } from './weekPipe';
import { ColoredInterval } from '../../models';
import { Strings } from '../../providers/globalData';

import { DateAdapter } from '@angular/material/core';
import {
  MatDateRangeSelectionStrategy,
  DateRange,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatCalendarCellCssClasses,
  MatDateRangePicker,
} from '@angular/material/datepicker';

import * as moment from 'moment';

@Injectable()
export class FiveDayRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D>
{
  constructor(private _dateAdapter: DateAdapter<D>) {

    _dateAdapter.getFirstDayOfWeek = () => 1;

  }

  selectionFinished(date: D | null): DateRange<D> {
    return new DateRange<D>(date, date);
    //return this._createFiveDayRange(date);
  }

  createPreview(activeDate: D | null): DateRange<D> {
    return this._createFiveDayRange(activeDate);
  }

  private _createFiveDayRange(date: D | null): DateRange<D> {
    if (date) {
      const getCurrentDay = this._dateAdapter.getDayOfWeek(date);
      console.log(getCurrentDay);
      let startingDay = 3;
      let closeToStartingDay = startingDay - getCurrentDay;

      if (getCurrentDay < startingDay) closeToStartingDay = closeToStartingDay - 7;

      const start = this._dateAdapter.addCalendarDays(date, closeToStartingDay);
      const end = this._dateAdapter.addCalendarDays(date, closeToStartingDay + 6);
      return new DateRange<D>(start, end);
    }

    return new DateRange<D>(null, null);
  }
}

/** @title Date range picker with custom a selection strategy */
@Component({
  selector: 'week-calendar',
  templateUrl: 'weekCalendarComponent.html',
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: FiveDayRangeSelectionStrategy,
    }
  ],
})
export class WeekCalendarComponent {
  @ViewChild(MatDateRangePicker)
  datePicker: MatDateRangePicker<Date>;

  dateClass = (date: Date): MatCalendarCellCssClasses => {

    const day = date.getDay();
    let prefix = '';
    if (day === 1 || date.getDate() === 1) {
      if (day !== 1 && date.getDate() === 1) {
        prefix = 'date-indent-' + day + ' ';
      }
      const isoWeek = moment(date).isoWeek(); // Calculate ISO week using Moment.js
      prefix += 'show-iso-week iso-week-' + isoWeek + ' ';
    }


    let $class = " " + this.getClass(date);

    if ($class)
      prefix += $class;

    if (!this.isDateEnabled(date))
      prefix += " cal-disabled";

    return prefix;
  };

  // OLD STUFF

  viewDate: Date = new Date();

  @Input()
  startDate: Date = new Date();

  @Input()
  coloredIntervals: ColoredInterval[] = [];

  @Input()
  unselectableIntervals: ColoredInterval[] = [];

  @Input()
  disableAllSelection = false;

  @Output()
  onValueChanged = new EventEmitter();

  constructor(public cd: ChangeDetectorRef,
    public strings: Strings) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['coloredIntervals'] || changes['unselectableIntervals']) {

      // Trigger refresh, intervals repaint.
      this.viewDate = new Date(this.viewDate.valueOf());
    }
  }

  dayClicked(): void {

    let date = this.datePicker.startAt;

    if (!date)
      return;

    let weekPipe = new WeekPipe();
    let week = weekPipe.transform(date);

    const getCurrentDay = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const startingDay = 3; // 3 = Wednesday
    let closeToStartingDay = startingDay - getCurrentDay;

    if (getCurrentDay < startingDay) {
      closeToStartingDay -= 7;
    }

    const startDate = new Date(date);
    startDate.setDate(startDate.getDate() + closeToStartingDay);

    let endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 6); 

    let dateRange = `${moment(startDate).format('YYYY-MM-DD')} - ${moment(endDate).format('YYYY-MM-DD')}`;

    this.onValueChanged.emit({ week: week, date: date, dateRange: dateRange });
  }

  getMonday(date : Date) : Date {

    let copyOf = new Date(date.valueOf())

    var day = date.getDay(),
      // First day is monday.
      diff = date.getDate() - day + (day == 0 ? -6 : 1);
    return new Date(copyOf.setDate(diff));
}

  beforeMonthViewRender(renderEvent/*: CalendarMonthViewBeforeRenderEvent*/): void {
    renderEvent.body.forEach((day) => {

      let $class = this.getClass(day.date);

      if ($class)
        day.cssClass = $class;

      if (!this.isDateEnabled(day.date)) {
        if (day.cssClass)
          day.cssClass += " cal-disabled";
        else
          day.cssClass = "cal-disabled";
      }

    });
  }

  isDateEnabled(date: Date) : boolean {

    if (this.disableAllSelection)
      return false;

    var begin;
    var end;

    if (this.unselectableIntervals) {

      var length = this.unselectableIntervals.length;

      // See all of the intervals.
      for (var i = 0; i < length; i++) {
        var unselectableInterval = this.unselectableIntervals[i];

        // Is there a begin?
        if (unselectableInterval.begin)
          begin = unselectableInterval.begin.split("-");
        else
          begin = null;

        // Is there an end?
        if (unselectableInterval.end)
          end = unselectableInterval.end.split("-");
        else
          end = null;

        // if both begin and end, see if the date is in between and return false (none selectable date).
        if (begin && end) {
          var d1 = new Date(begin[0], begin[1] - 1, begin[2], 0, 0, 0, 0);
          var d2 = new Date(end[0], end[1] - 1, end[2], 0, 0, 0, 0);

          if (date >= d1 && date <= d2) {
            return false;
          }
        }
        else if (begin) {
          // There is no end date in this interval.
          var d1 = new Date(begin[0], begin[1] - 1, begin[2], 0, 0, 0, 0);

          if (date >= d1) {
            return false;
          }
        }
        else if (end) {
          // There is no begin date in this interval.
          var d2 = new Date(end[0], end[1] - 1, end[2], 0, 0, 0, 0);

          if (date <= d2) {
            return false;
          }
        }
        else {
          // Everything is unselectable.
          return false;
        }
      }
    }

    return true;

  }

  getClass(date: Date) : string {
    var begin;
    var end;

    if (this.coloredIntervals) {

      var length = this.coloredIntervals.length;

      // For every colored iterval, look for a match.
      for (var i = 0; i < length; i++) {
        var coloredInterval = this.coloredIntervals[i];

        // Is there a begin?
        if (coloredInterval.begin)
          begin = coloredInterval.begin.split("-");
        else
          begin = null;

        // Is there an end?
        if (coloredInterval.end)
          end = coloredInterval.end.split("-");
        else
          end = null;

        // if both begin and end, see if the date is in between and return the class.
        if (begin && end) {
          var d1 = new Date(begin[0], begin[1] - 1, begin[2], 0, 0, 0, 0);
          var d2 = new Date(end[0], end[1] - 1, end[2], 0, 0, 0, 0);

          if (date >= d1 && date <= d2) {
            return coloredInterval.cssClass;
          }
        }
        else if (begin) {
          // There is no end date in this interval.
          var d1 = new Date(begin[0], begin[1] - 1, begin[2], 0, 0, 0, 0);

          if (date >= d1) {
            return coloredInterval.cssClass;
          }
        }
        else if (end) {
          // There is no begin date in this interval.
          var d2 = new Date(end[0], end[1] - 1, end[2], 0, 0, 0, 0);

          if (date <= d2) {
            return coloredInterval.cssClass;
          }
        }
        else {
          // Everything is selected.
          return coloredInterval.cssClass;
        }
      }
    }

    return null;
  }
}
